<template>
    <nav v-if="authStore.authenticated" class="navbar navbar-static-top p-0 bg-default d-print-none">
        <div class="container-fluid">
            <div class="navbar-left">
                <a href="/" class="navbar-header p-1">
                    <el-avatar :size="40" :src="logo" />
                </a>
                <!-- <RouterLink :to="{ name: 'menu' }" class="bar-icon p-10" role="button">
                    <i class="fa fa-bars"></i>
                </RouterLink> -->
            </div>

            <div class="main-navbar">
                <div class="nav nav-scroller align-items-center nav-scroller--controls-inline" v-if="user.menus && user.menus.length">
                    <div class="navbar nav-scroller-nav p-0">
                        <div class="nav-scroller-content">
                            <template v-for="menu in user.menus">
                                <el-dropdown trigger="click" v-if="menu.children.length" popper-class="nav-scroller-item" ref="dropdownRef" :key="menu.id">
                                    <span class="el-dropdown-link nav-scroller-item d-flex align-items-center">
                                        <span>{{ menu.name_english }}</span>
                                        <el-icon class="el-icon--right text-white"><arrow-down /></el-icon>
                                    </span>
                                    <template #dropdown>
                                        <el-dropdown-menu class="custom-dropdown-menu">
                                            <el-dropdown-item @click="closeDropdown" class="dropdown-wrapper overflow-y-scroll flex-column">
                                                <div class="dropdown-content">
                                                    <div class="col-sx-6 d-flex content-left px-0">
                                                        <div class="dropdown-links-list">
                                                            <template v-for="(child, i) in menu.children">
                                                                <div class="dropdown-links-list-item" v-if="menu.children.length && child.type > 1" :key="i">
                                                                    <RouterLink :to="{ name: child.route }" class="text-decoration-none">
                                                                        {{ child.name_english }}
                                                                    </RouterLink>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>

                                                    <div class="col-sx-6 d-flex content-right px-0">
                                                        <div class="dropdown-links-list">
                                                            <template v-for="(child, i) in menu.children">
                                                                <div class="dropdown-links-list-item" v-if="menu.children.length && child.type <= 1" :key="i">
                                                                    <RouterLink :to="{ name: child.route }" class="text-decoration-none">
                                                                        {{ child.name_english }}
                                                                    </RouterLink>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </template>
                                </el-dropdown>
                            </template>
                        </div>
                    </div>

                    <button class="nav-scroller-btn nav-scroller-btn--left d-flex align-items-center p-0" aria-label="Scroll left">
                        <i class="fa fa-chevron-left"></i>
                    </button>

                    <button id="nav-scroller-btn-right" class="nav-scroller-btn nav-scroller-btn--right d-flex align-items-center p-0" aria-label="Scroll right">
                        <i class="fa fa-chevron-right"></i>
                    </button>
                </div>
            </div>

            <div class="navbar-custom-menu me-2">
                <el-dropdown trigger="click">
                    <span class="el-dropdown-link d-flex align-items-center">
                        <span class="d-inline-block">
                            <el-avatar :size="40" :src="user.avatar || 'img/default.png'" />
                        </span>
                        <span class="d-none d-sm-inline-block text-white ml-10"> {{ user.service_no }} </span>
                        <el-icon class="el-icon--right text-white"><arrow-down /></el-icon>
                    </span>
                    <template #dropdown>
                        <el-dropdown-menu>
                            <!-- <el-dropdown-item class="pt-0 pb-0 pl-5 pr-5">
                                <el-autocomplete
                                    v-model="search_user_id"
                                    :fetch-suggestions="querySearchAsync"
                                    :trigger-on-focus="false"
                                    :debounce="500"
                                    prefix-icon="el-icon-search"
                                    placeholder="ব্যক্তি অনুসন্ধান"
                                    @select="handleSelect"
                                    value-key="name_bangla"
                                    class="d-block"
                                    clearable
                                >
                                    <template #default="{ item }">
                                        <div class="value">{{ item.rank_bangla }} {{ item.name_bangla }}</div>
                                        <span class="link">{{ item.service_bangla }}</span>
                                    </template>
                                </el-autocomplete>
                            </el-dropdown-item> -->

                            <!-- <el-dropdown-item divided class="pt-0 pb-0 pl-5 pr-5">
                                <router-link :to="{ name: 'user-activity' }" class="p-1"> Activity</router-link>
                            </el-dropdown-item> -->

                            <!-- <el-dropdown-item divided class="pt-0 pb-0 pl-5 pr-5">
                                <router-link :to="{ name: 'sheet-roll-basic', params: { id: user.id } }"> Sheet Roll</router-link>
                            </el-dropdown-item> -->

                            <el-dropdown-item class="pt-0 pb-0 pl-15 pr-15">
                                <router-link :to="{ name: 'complaint-list' }" class="text-decoration-none"> Complaint </router-link>
                            </el-dropdown-item>

                            <el-dropdown-item divided class="pt-0 pb-0 pl-15 pr-15">
                                <router-link :to="{ name: 'change.password' }" class="text-decoration-none"> Change Password</router-link>
                            </el-dropdown-item>

                            <el-dropdown-item divided class="pt-0 pb-0 pl-15 pr-15">
                                <a href="#" @click.prevent="signOut()" class="text-decoration-none">Sign out</a>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </template>
                </el-dropdown>
            </div>
        </div>
    </nav>
</template>

<script setup>
import { RouterLink } from "vue-router";
import PriorityNavScroller from "priority-nav-scroller";
import { ref, onMounted, onBeforeUnmount, nextTick } from "vue";

import { useAuthStore } from "@/store/auth";
import { useRouter, useRoute } from "vue-router";

const authStore = useAuthStore();
const router = useRouter();
const route = useRoute();

const dropdownRef = ref([]);

const closeDropdown = () => {
    dropdownRef.value.forEach((d) => d?.handleClose());
};

const props = defineProps({
    user: {
        type: Object,
        required: true,
    },
});

const logo = ref("logo.png");

const search_user_id = ref("");

const querySearchAsync = (queryString, cb) => {
    if (queryString === "") return;

    axios
        .get(`/api/admin/search-users?q=${queryString}`)
        .then((res) => {
            cb(res.data.data);
        })
        .catch((err) => {
            console.log("Err: ", err);
        });
};

const NavScroll = () => {
    PriorityNavScroller({
        selector: ".nav-scroller",
        navSelector: ".nav-scroller-nav",
        contentSelector: ".nav-scroller-content",
        itemSelector: ".nav-scroller-item",
        buttonLeftSelector: ".nav-scroller-btn--left",
        buttonRightSelector: ".nav-scroller-btn--right",
        scrollStep: 80,
    });
};

const handleSelect = (item) => {
    router.push({ name: "report.rp.user.details", params: { service_no: item.service_no } });
};

const signOut = async () => {
    // loading.value = true;
    // errors.value = {}; // Clear previous errors
    try {
        await authStore.logout();
        router.push({ name: "login" });
    } catch (error) {
        if (error.response && error.response.data) {
            errors.value = error.response.data.errors || { root: error.response.data.message };
        } else {
            errors.value = { root: "An unexpected error occurred." };
        }
    } finally {
        // loading.value = false;
    }
};

onMounted(() => {
    if (authStore.authenticated) {
        NavScroll();
        logo.value = props.user.logo;
    } else {
        logo.value = "logo.png";
    }
});
</script>
